module.exports = __webpack_public_path__ + "static/media/about-huge.4cba9b40.jpg";